import React from 'react'

export default function Skills() {
    const skills = ['Javascript', 'React.js', 'HTML', 'CSS', 'Bootstrap', 'TailwindCSS', 'MongoDB', 'Node.js', 'Express.js', 'C++', 'Java', 'Firebase', 'React Router', 'ES6']
    return (
        <div className='md:mx-12 mx-4 my-20'>
            <div className='flex justify-center gap-2 items-center mb-8 md:mb-12'>
                <div className=' w-12 h-0.5 bg-white'></div>
                <h3 className=' text-white font-bold lg:text-3xl md:text-2xl text-lg text-center'>My Skills</h3>
                <div className=' w-12 h-0.5 bg-white'></div>
            </div>
            <div className='flex flex-wrap justify-center gap-6 grid-cols-2 md:grid-cols-3 lg:grid-cols-6 '>
                {
                    skills.map((skill, index) => <p className='border text-center rounded-lg shadow-md shadow-white  p-4 text-green-500 uppercase font-bold' key={index}>
                        {skill}
                    </p>)
                }
            </div>
        </div>
    )
}
